// hooks/useVenueCart.js
import { useEffect, useState } from 'react';
import {
  fetchVenueCartAPI,
  deleteVenueCartItemAPI,
  updateVenueCartItemAPI,
  refundvenuefromcartapi,
} from '../Apiservices/Auth/cart/Addtocart_api';
import { useDispatch } from 'react-redux';
import { addServiceToCart, removeVenueByProviderId } from '../store/cartbodydataslice';

export const useVenueCart = () => {
  const [venueCartData, setVenueCartData] = useState([]);
  const [venueCartLoading, setVenueCartLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchVenueCart = async () => {
      setVenueCartLoading(true);
      try {
        const response = await fetchVenueCartAPI();
        console.log("venue cart data", response);
        
        if (response.success && response.data) {
          response.data.forEach((cartItem) => {
            const eveId = cartItem.event_id;
            const eventname = cartItem.event_title;
            const event_start_date = cartItem.event_start_date;
            
            cartItem.venueItems.forEach((venueItem) => {
              // Transform food selections
              const foodSelections = venueItem.foodSelections?.map(food => ({
                id: food.id,
                menuId: food.menuId,
                guestCount: food.guestCount,
                pricePerPerson: food.pricePerPerson,
                subtotal: food.subtotal,
                menuName: food.menu?.name || '',
                menuPrice: food.menu?.price || '',
              })) || [];

              // Transform drink selections
              const drinkSelections = venueItem.drinkSelections?.map(drink => ({
                id: drink.id,
                drinkOptionId: drink.drinkOptionId,
                guestCount: drink.guestCount,
                pricePerPerson: drink.pricePerPerson,
                subtotal: drink.subtotal,
                drinkName: drink.drinkOption?.name || '',
                drinkPrice: drink.drinkOption?.pricePerPerson || '',
              })) || [];

              dispatch(
                addServiceToCart({
                  eveId,
                  eventname: eventname,
                  event_start_date: event_start_date,
                  type: 'venueData',
                  item: {
                    ...venueItem,
                    id: venueItem.id,
                    cartId: venueItem.cartId,
                    venueId: venueItem.venueId,
                    spaceId: venueItem.spaceId,
                    provider_id: venueItem.providerId,
                    provider_name: venueItem.provider?.name || '',
                    provider_mobile: venueItem.provider?.mobileNumber || '',
                    provider_email: venueItem.provider?.emailId || '',
                    venue_name: venueItem.venue?.name || '',
                    venue_address: venueItem.venue?.address || '',
                    venue_description: venueItem.venue?.description || '',
                    section_name: venueItem.section?.name || '',
                    section_capacity: venueItem.section?.capacity || '',
                    pricing_type: venueItem.pricingType,
                    food_included: venueItem.foodIncluded,
                    outside_food_allowed: venueItem.outsideFoodAllowed,
                    no_of_guests: venueItem.noOfGuests,
                    from_date: venueItem.fromDate,
                    from_time: venueItem.fromTime,
                    to_date: venueItem.toDate,
                    to_time: venueItem.toTime,
                    rules_accepted: venueItem.rulesAccepted,
                    base_price: venueItem.basePrice,
                    food_total: venueItem.foodTotal,
                    drink_total: venueItem.drinkTotal,
                    subtotal: venueItem.subtotal,
                    gst_percentage: venueItem.gstPercentage,
                    gst_amount: venueItem.gstAmount,
                    total_amount: venueItem.totalAmount,
                    paid_amount: venueItem.paidAmount,
                    balance_to_be_paid: venueItem.balanceToBePaid,
                    is_checked_out: venueItem.isCheckedOut,
                    is_edit_allowed: venueItem.isEditAllowed,
                    is_canceled: venueItem.isCanceled,
                    is_pay_later: venueItem.isPayLater,
                    refunded_amount: venueItem.refundedAmount,
                    booking_date: venueItem.booking_date,
                    start_time: venueItem.start_time,
                    end_time: venueItem.end_time,
                    guest_count: venueItem.guest_count,
                    foodSelections: foodSelections,
                    drinkSelections: drinkSelections,
                    pricing: venueItem.pricing,
                    paymentSummary: venueItem.paymentSummary,
                    // Keep the original structure for compatibility
                    services: [{
                      ...venueItem,
                      id: venueItem.id,
                      cart_id: venueItem.cartId,
                      price: venueItem.subtotal,
                      discountPrice: venueItem.subtotal,
                      validUpto: null,
                      quantity: 1,
                      service_name: `Venue: ${venueItem.venue?.name || ''} - ${venueItem.section?.name || ''}`,
                    }],
                    total: venueItem.totalAmount || venueItem.subtotal || 0,
                  },
                })
              );
            });
          });
          
          setVenueCartData(response.data || []);
        } else {
          setVenueCartData([]);
        }
      } catch (err) {
        console.error('Error loading venue cart:', err);
        setVenueCartData([]);
      }
      setVenueCartLoading(false);
    };

    fetchVenueCart();
  }, [refreshTrigger, dispatch]);

  const refreshVenueCart = () => setRefreshTrigger((prev) => prev + 1);

  const removeVenueProvider = async (cartItemId) => {
    try {
      const result = await deleteVenueCartItemAPI(cartItemId);
      dispatch(removeVenueByProviderId({ cartItemId }));
      refreshVenueCart();
      return result;
    } catch (error) {
      console.error("Error removing venue cart item:", error);
      throw error;
    }
  };

  const updateVenueCartItem = async (cartItemId, updatedData) => {
    try {
      const result = await updateVenueCartItemAPI(cartItemId, updatedData);
      refreshVenueCart();
      return { success: true, message: "Venue cart updated successfully", data: result };
    } catch (err) {
      console.error("Update venue cart error:", err);
      return { success: false, message: err.message || "Failed to update venue cart" };
    }
  };

  const refundVenueProvider = async (event_id, provider_id) => {
    try {
      const response = await refundvenuefromcartapi(event_id, provider_id);
      refreshVenueCart();
      return response;
    } catch (error) {
      console.error("Refund Venue from cart error:", error.message);
      throw error;
    }
  };

  return {
    venueCartData,
    venueCartLoading,
    refreshVenueCart,
    removeVenueProvider,
    updateVenueCartItem,
    refundVenueProvider,
  };
};